<template>
  <div class="wrapper centered landing">
    <main class="content">
      <header class="page landing">
        <h1 class="title" :class="{'is-loading': mixFound && !fetchError}"><span>My SeedMix</span></h1>
        <p class="subtitle" v-text="loadingStatus"></p>
        <p v-if="fetchError">
          <button class="btn btn-primary" @click.prevent="handleNewMix">Start a New Mix</button>
        </p>
      </header>
    </main>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: ['id'],
  data () {
    return {
      loadingStatus: 'fetching mix...',
      fetchError: false,
      mixFound: false
    }
  },
  methods: {
    handleNewMix () {
      this.$store.commit('reset')
      this.$router.push({
        name: 'getting-started'
      })
    }
  },
  mounted () {
    axios.get(this.$store.state.storeDomain + '/wp-json/millborn/v1/get/' + this.id)
      .then(response => {
        this.loadingStatus = 'loading mix...'
        this.mixFound = true
        if (response.data.result === 'success') {
          // make sure we have the pieces we expect
          let savedState = response.data.data
          if ('path' in savedState && 'formData' in savedState) {
            this.$store.state.formData = savedState.formData
            this.$emit('updateTotals')
            setTimeout(() => {
              this.$router.push({
                path: savedState.path
              })
            }, 4500)
          } else {
            this.loadingStatus = 'Sorry, this mix couldn\'t be resumed'
            this.fetchError = true
            // console.log('Mix found, but did not include path and formData.')
          }
        } else {
          this.fetchError = true
          this.loadingStatus = 'Sorry, we couldn\'t find that mix'
        }
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>
<style lang="scss">

</style>
